export const formatPrice = (number) => {
  const newNumber = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'INR',
     minimumFractionDigits: 0, 
  }).format(number);
  return newNumber;
};

export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);
  unique = unique.filter(item => item !== undefined);

  if (type === 'colors') {
    unique = unique.flat();
  }
  if(type==="offers"){
    unique=data.map((e)=>e?.bestOffers?.description)
  }
   
  unique = new Set(unique);
  return ['all', ...unique];
};

export const checkObjectProperties = (object) => {
  const isEmpty = Object.values(object).every((x) => x === null || x === '');
  return isEmpty;
};

export const formatAddress = (data) => {
  const {
    shippingInfo: { address, city, state, country, pinCode },
  } = data;
  return `${address}, ${city}, ${state} - ${pinCode}, ${country}`;
};

export const getOrderStatusColor = (status) => {
  if (status === 'processing') {
    return 'var(--clr-orange)';
  }
  if (status === 'rejected') {
    return 'var(--clr-red-dark)';
  }
  if (status === 'Refund Rejected') {
    return 'var(--clr-red-dark)';
  }
  return 'var(--clr-green-dark)';
};
